import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import cx from 'classnames';
import { Button } from '@storable/canaveral-components';
import { formatSize } from '../../../modules/assets';
import styles from './styles.scss';

const propTypes = {
  formattedCreatedAt: PropTypes.string.isRequired,
  formattedUpdatedAt: PropTypes.string.isRequired,
  addedBy: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  sourceHeight: PropTypes.string.isRequired,
  sourceWidth: PropTypes.string.isRequired,
  sourceSize: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
const defaultProps = {};

const MediaGalleryFileInfo = ({
  formattedCreatedAt,
  formattedUpdatedAt,
  addedBy: { name },
  sourceHeight,
  sourceWidth,
  sourceSize,
  type,
  url,
}) => {
  const [showFileInfo, setShowFileInfo] = useState(true);
  const toggleFileInfo = () => setShowFileInfo(!showFileInfo);

  return (
    <div className={styles.fileInfo}>
      <div className={styles.fileInfoHeader}>
        <Button className={styles.fileInfoButton} context="bare" onClick={toggleFileInfo}>
          File Info
          <span className={cx('fa', `fa-angle-${showFileInfo ? 'up' : 'down'}`, styles.fileInfoToggle)} />
        </Button>
      </div>
      {showFileInfo && (
        <>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Date added
            </span>
            <span className={styles.info}>
              {formattedCreatedAt}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Date modified
            </span>
            <span className={styles.info}>
              {formattedUpdatedAt}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Original Size
            </span>
            <span className={styles.info}>
              {formatSize(parseInt(sourceSize, 10))}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Original Resolution
            </span>
            <span className={styles.info}>
              {sourceWidth}x{sourceHeight}px
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Type
            </span>
            <span className={styles.info}>
              {type}
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              URL
            </span>
            <span className={styles.info}>
              <CopyToClipboard text={url}>
                <Button context="bare" className={styles.copyLink}>
                  Copy Link
                </Button>
              </CopyToClipboard>
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoHeader}>
              Added by
            </span>
            <span className={styles.info}>
              {name}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

MediaGalleryFileInfo.propTypes = propTypes;
MediaGalleryFileInfo.defaultProps = defaultProps;

MediaGalleryFileInfo.fragments = {
  medium: gql`
    fragment MediaGalleryFileInfoMedium on Medium {
      formattedCreatedAt
      formattedUpdatedAt
      addedBy {
        name
      }
      sourceHeight
      sourceWidth
      sourceSize
      type
      url
    }
  `,
};

export default MediaGalleryFileInfo;
